<template>
  <div>
    <div class="logis">
      <img class="left" src="../../assets/images/icon_101.png" />
      <div class="center">
        <div>
          <span>物流公司：</span>
          {{oederCm}}
        </div>
        <div style="display: flex;justify-content: flex-start;">
          <div>物流单号：</div>
          <div style="padding-right:10px;">{{oederSn}}</div>
          <div class="tag-read" :data-clipboard-text="oederSn" @click="copy">复制</div>
        </div>
      </div>
      <img class="right" src="../../assets/images/icon_102.png" />
    </div>
    <div class="box_steps" v-if="courierTraces.length>0">
      <van-steps direction="vertical" :active="0" active-color="#07c160">
        <van-step v-for="(item, index) in courierTraces" :key="index" :class="'step_' + index">
          <h3>{{item.AcceptStation}}</h3>
          <p>{{item.AcceptTime}}</p>
        </van-step>
      </van-steps>
    </div>
    <div v-else style="text-align:center;margin-top:30vh;font-size:15px;">当前暂无物流信息更新</div>
  </div>
</template>

<script>
import { Step, Steps, Toast } from 'vant'
import { expreessInquiry } from '../../request/api.js'
import Clipboard from 'clipboard'
export default {
  name: 'orderCourier',
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Toast.name]: Toast
  },
  data () {
    return {
      oederCm: '', // 物流公司
      oederSn: '', // 物流单号
      courierTraces: [] // 物流记录
    }
  },
  created () {
    this.oederCm = this.$route.query.cm
    this.oederSn = this.$route.query.sn
    this.loadCourier()
  },
  methods: {
    async loadCourier () {
      const res = await expreessInquiry({
        courierNumber: this.oederSn,
        courierCompany: this.oederCm
      })
      console.log(res)
      if (res.code === 200) {
        this.courierTraces = res.data.reverse()
      }
    },
    copy() {
      console.log(11)
      this.$nextTick(() => {
        var clipboard = new Clipboard('.tag-read')
        clipboard.on('success', e => {
          Toast('复制成功')
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
        // 不支持复制
          Toast('复制成功')
          // 释放内存
          clipboard.destroy()
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
@pierce: ~">>>";
@widthframe: 690px;
* {
  box-sizing: border-box;
}
.logis {
  width: 100%;
  height: 198px;
  padding: 48px 30px;
  position: relative;
  overflow: hidden;
  .left {
    float: left;
    width: 102px;
    height: 102px;
    margin-right: 36px;
  }
  .center {
    float: left;
    width: 550px;
    div {
      float: left;
      width: 100%;
      font-size: 28px;
      margin-top: 8px;
      span {
        float: left;
        color: #666;
      }
    }
  }
  .right {
    width: 426px;
    height: 198px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: -999;
  }
}
.box_steps{
  padding: 20px;
  .van-step{
    padding: 25px 10px;
    &.step_0{
      padding-top: 0;
    }
    h3{
      line-height: 1.5;
      padding-bottom: 15px;
    }
    @{pierce} .van-step__circle{
      width: 5px; /* no*/
      height: 5px; /* no*/
    }
    @{pierce} .van-step__line{
      width: 1px; /* no*/
    }
  }
}
</style>
